// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__ZrAMc","item1":"style_item1__JhJd6","item2":"style_item2__JZ5Fa","item3":"style_item3__y2Kqc"};